import React from 'react';
import styled from '@emotion/styled';

const H2 = styled.h2({
  color: 'var(--color-primary)',
});

type Props = {
  title: string;
};

export const CostHeader: React.FC<Props> = ({ title }) => {
  return (
    <>
      <H2 data-testid='mp-product-cost-title'>{title}</H2>
    </>
  );
};
